const initialState = {
  articles: [],
  totalPages: 1,
  currentPage: 1,
  singleArticle: null,
  getArticlesLoader: false,
  singleArticleLoader: false,
  saveArticleLoader: false,
  deleteArticleLoader: false,
  settings: {
    adminEmail: "",
    supportEmail: "",
    escalationEmails: [],
  },
  settingsLoader: false,
  saveSettingsLoader: false,
  feedbackSummary: null,
  feedbackLoader: false,
  auditLogs: [],
  auditLoader: false,
  auditTotalPages: 1,
  auditCurrentPage: 1,
};

const chatbotKnowledgeReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "GET_CHATBOT_KNOWLEDGE":
      return {
        ...state,
        articles: payload.articles,
        totalPages: payload.totalPages,
        currentPage: payload.currentPage,
      };

    case "GET_CHATBOT_KNOWLEDGE_LOADER":
      return {
        ...state,
        getArticlesLoader: payload,
      };

    case "GET_SINGLE_CHATBOT_KNOWLEDGE":
      return {
        ...state,
        singleArticle: payload,
      };

    case "GET_SINGLE_CHATBOT_KNOWLEDGE_LOADER":
      return {
        ...state,
        singleArticleLoader: payload,
      };

    case "CLEAR_SINGLE_CHATBOT_KNOWLEDGE":
      return {
        ...state,
        singleArticle: null,
      };

    case "SAVE_CHATBOT_KNOWLEDGE_LOADER":
      return {
        ...state,
        saveArticleLoader: payload,
      };

    case "UPDATE_CHATBOT_KNOWLEDGE_SUCCESS":
      return {
        ...state,
        singleArticle: payload,
        articles: state.articles.map((item) =>
          item._id === payload?._id || item.id === payload?.id ? payload : item
        ),
      };

    case "DELETE_CHATBOT_KNOWLEDGE_LOADER":
      return {
        ...state,
        deleteArticleLoader: payload,
      };

    case "CHATBOT_KNOWLEDGE_DELETED":
      return {
        ...state,
        articles: state.articles.filter(
          (item) => item._id !== payload && item.id !== payload
        ),
      };

    case "GET_CHATBOT_SETTINGS":
      return {
        ...state,
        settings: payload,
      };

    case "GET_CHATBOT_SETTINGS_LOADER":
      return {
        ...state,
        settingsLoader: payload,
      };

    case "SAVE_CHATBOT_SETTINGS_LOADER":
      return {
        ...state,
        saveSettingsLoader: payload,
      };

    case "GET_CHATBOT_FEEDBACK_SUCCESS":
      return {
        ...state,
        feedbackSummary: payload,
      };

    case "GET_CHATBOT_FEEDBACK_LOADER":
      return {
        ...state,
        feedbackLoader: payload,
      };

    case "GET_CHATBOT_AUDIT_SUCCESS":
      return {
        ...state,
        auditLogs: payload.logs,
        auditTotalPages: payload.totalPages,
        auditCurrentPage: payload.currentPage,
      };

    case "GET_CHATBOT_AUDIT_LOADER":
      return {
        ...state,
        auditLoader: payload,
      };

    default:
      return state;
  }
};

export default chatbotKnowledgeReducer;
